import BaseCollection from "scripts/collections/baseCollection";
import AuthenticationCollectionHoc from "scripts/hoc/authenticationCollectionHoc";

class BaseAuthenticationCollection extends AuthenticationCollectionHoc(
  BaseCollection,
) {}

export default BaseAuthenticationCollection;
